import { createContext, useContext, useState } from 'react'
import { iItemFeedbackResponse, iParticipanteFeedbackResponse } from '../../interfaces'

interface iModel {
  participantesFeedback: iParticipanteFeedbackResponse[]
  itemsFeedback: iItemFeedbackResponse[]
  dataInicio?: string
  textoEmail?: string
  iniciado?: boolean
  temPDI?: boolean
  temPesquisa?: boolean
  enviarAtrasados?: boolean
  intervaloDias?: number
}

type Ctx = {
  InputsFormularioFeedback: iModel
  setInputsFormularioFeedback: (value: Partial<iModel>) => void
  resetInputsFormularioFeedback: () => void
}

const InputsFormularioFeedbackContext = createContext<Ctx | null>(null)

export const InputsFormularioFeedbackProvider = ({
  children
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [state, setState] = useState<iModel>({
    participantesFeedback: [],
    itemsFeedback: [],
    dataInicio: '',
    textoEmail: '<p>Olá, <strong>[NOME DO PARTICIPANTE]</strong>!</p><p>Você foi inserido no feedback <strong>[NOME DO FEEDBACK]</strong> que terá início no dia <strong>[DATA INICIO]</strong>.</p><p>Você pode acompanhar seu progresso na plataforma do SAH através do link abaixo:</p><p><strong>[LINK]</strong></p><p>A sua participação é fundamental para o sucesso dessa iniciativa.</p><p>Caso tenha dúvidas, por favor contatar o responsável pelo seu feedback através do email: <strong>[EMAIL DO GESTOR]</strong></p><p>Contamos com você!</p>',
    iniciado: false,
    temPDI: false,
    temPesquisa: false,
    enviarAtrasados: false,
    intervaloDias: undefined
  })

  const setInputsFormularioFeedback = (value: Partial<iModel>): void => {
    setState(prev => ({ ...prev, ...value }))
  }

  const resetInputsFormularioFeedback = (): void => {
    setState({
      participantesFeedback: [],
      itemsFeedback: [],
      dataInicio: '',
      textoEmail: '<p>Olá, <strong>[NOME DO PARTICIPANTE]</strong>!</p><p>Você foi inserido no feedback <strong>[NOME DO FEEDBACK]</strong> que terá início no dia <strong>[DATA INICIO]</strong>.</p><p>Você pode acompanhar seu progresso na plataforma do SAH através do link abaixo:</p><p><strong>[LINK]</strong></p><p>A sua participação é fundamental para o sucesso dessa iniciativa.</p><p>Caso tenha dúvidas, por favor contatar o responsável pelo seu feedback através do email: <strong>[EMAIL DO GESTOR]</strong></p><p>Contamos com você!</p>',
      iniciado: false,
      temPDI: false,
      temPesquisa: false,
      enviarAtrasados: false,
      intervaloDias: undefined
    })
  }

  return (
    <InputsFormularioFeedbackContext.Provider
      value={{
        InputsFormularioFeedback: state,
        setInputsFormularioFeedback,
        resetInputsFormularioFeedback
      }}
    >
      {children}
    </InputsFormularioFeedbackContext.Provider>
  )
}

export const useInputsFormularioFeedback = (): Ctx => {
  const ctx = useContext(InputsFormularioFeedbackContext)

  if (!ctx) {
    throw new Error(
      'useInputsFormularioFeedback deve ser usado dentro do InputsFormularioFeedbackProvider'
    )
  }

  return ctx
}
